/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital-access.reducer';

export const HospitalAccessDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalAccessEntity = useAppSelector(state => state.hospitalAccess.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalAccessDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospitalAccess.detail.title">HospitalAccess</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospitalAccess.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalAccessEntity.id}</dd>
          <dt>
            <span id="uhid">
              <Translate contentKey="tinyMedicRestApp.hospitalAccess.uhid">Uhid</Translate>
            </span>
          </dt>
          <dd>{hospitalAccessEntity.uhid}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospitalAccess.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalAccessEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="revoked">
              <Translate contentKey="tinyMedicRestApp.hospitalAccess.revoked">Revoked</Translate>
            </span>
          </dt>
          <dd>{hospitalAccessEntity.revoked ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.hospitalAccess.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{hospitalAccessEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospitalAccess.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{hospitalAccessEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.hospitalAccess.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{hospitalAccessEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospitalAccess.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalAccessEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalAccess.comboUser">Combo User</Translate>
          </dt>
          <dd>{hospitalAccessEntity.comboUser ? hospitalAccessEntity.comboUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalAccess.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{hospitalAccessEntity.glucoUser ? hospitalAccessEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hospital-access" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hospital-access/${hospitalAccessEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalAccessDetail;
